import { render } from "./SideBar.vue?vue&type=template&id=48ec3bd9&scoped=true&ts=true"
import script from "./SideBar.vue?vue&type=script&lang=ts"
export * from "./SideBar.vue?vue&type=script&lang=ts"

import "./SideBar.vue?vue&type=style&index=0&id=48ec3bd9&scoped=true&lang=scss"

import exportComponent from "/home/yjmthu/github/vua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ec3bd9"]])

export default __exports__